// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Bq-z","imageAndVideoCount":"Cq-z","imageAndVideoContainer":"Dq-z","viewAllReviews":"Eq-z"};